/* مشغّل فيديو نبأ: غلاف + زر تشغيل؛ عند التشغيل تظهر أدوات التحكم الأصلية ويتوقف أي مقطع آخر */
(function(){
  var players = document.querySelectorAll('[data-naba-video]');
  if (!players.length) return;
  function pauseOthers(me){
    players.forEach(function(p){ var v = p.querySelector('video'); if (v && v !== me && !v.paused) v.pause(); });
  }
  players.forEach(function(p){
    var v = p.querySelector('video'), btn = p.querySelector('.n-vplay');
    if (!v) return;
    function play(){ pauseOthers(v); v.controls = true; var r = v.play(); if (r && r.catch) r.catch(function(){}); }
    btn && btn.addEventListener('click', function(e){ e.preventDefault(); play(); });
    p.addEventListener('click', function(e){ if (!p.classList.contains('is-playing') && e.target !== btn) play(); });
    v.addEventListener('play', function(){ p.classList.add('is-playing'); });
    v.addEventListener('pause', function(){ if (v.ended || v.currentTime === 0) { p.classList.remove('is-playing'); v.controls = false; } });
    v.addEventListener('ended', function(){ p.classList.remove('is-playing'); v.controls = false; try { v.currentTime = 0; } catch (_) {} });
  });
  // إيقاف المقطع إذا خرج من الشاشة
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ var v = e.target.querySelector('video'); if (v && !e.isIntersecting && !v.paused) v.pause(); }); }, {threshold: .1});
    players.forEach(function(p){ io.observe(p); });
  }
})();
